import { apiClient } from './apiClient';
const scopeKey = 'Lead Management';
const BASE_URL = '/lead/management';

export const expansionInquiryService = {
    checkIsAlreadyFormFill: async (
        contactEmail: string,
        membershipNumber: number
    ): Promise<any> => {
        return await apiClient.get<any>(
            `${BASE_URL}/form-submission-exists?scopeKey=${scopeKey}&contactEmail=${contactEmail}&membershipNumber=${membershipNumber}`
        );
    },
    checkAttractionFormSubmissionExists: async (
        contactEmail: string
    ): Promise<any> => {
        return await apiClient.get<any>(
            `${BASE_URL}/attraction-form-submission-exists?scopeKey=${scopeKey}&contactEmail=${contactEmail}`
        );
    },
    getAlreadyFormFillData: async (
        contactEmail: string,
        membershipNumber: number
    ): Promise<any> => {
        return await apiClient.get<any>(
            `${BASE_URL}/get-previously-form-data?scopeKey=${scopeKey}&contactEmail=${contactEmail}&membershipNumber=${membershipNumber}`
        );
    },
    createInquiry: async (payload: Partial<any>) => {
        return await apiClient.post(
            `${BASE_URL}/add-expansion-inquiry
`,
            payload
        );
    }
};
